import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDuplicate = createIcon({
  displayName: 'IconDuplicate',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M3 17H5V5H17V3H3V17ZM7 21H21V11H19V19H9V9H21V7H7V21Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
